// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/delete_my_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/delete_my_account.proto.
 */
export const file_accounts_delete_my_account: GenFile = /*@__PURE__*/
  fileDesc("CiBhY2NvdW50cy9kZWxldGVfbXlfYWNjb3VudC5wcm90bxIPcHJvdG9zLmFjY291bnRzImIKFkRlbGV0ZU15QWNjb3VudFJlcXVlc3QSPgoGcGFyYW1zGAEgASgLMi4ucHJvdG9zLmFjY291bnRzLkRlbGV0ZU15QWNjb3VudFJlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyJkChdEZWxldGVNeUFjY291bnRSZXNwb25zZRI/CgZyZXN1bHQYASABKAsyLy5wcm90b3MuYWNjb3VudHMuRGVsZXRlTXlBY2NvdW50UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z");

/**
 * @generated from message protos.accounts.DeleteMyAccountRequest
 */
export type DeleteMyAccountRequest = Message<"protos.accounts.DeleteMyAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.DeleteMyAccountRequest.Params params = 1;
   */
  params?: DeleteMyAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.DeleteMyAccountRequest.
 * Use `create(DeleteMyAccountRequestSchema)` to create a new message.
 */
export const DeleteMyAccountRequestSchema: GenMessage<DeleteMyAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_delete_my_account, 0);

/**
 * @generated from message protos.accounts.DeleteMyAccountRequest.Params
 */
export type DeleteMyAccountRequest_Params = Message<"protos.accounts.DeleteMyAccountRequest.Params"> & {
};

/**
 * Describes the message protos.accounts.DeleteMyAccountRequest.Params.
 * Use `create(DeleteMyAccountRequest_ParamsSchema)` to create a new message.
 */
export const DeleteMyAccountRequest_ParamsSchema: GenMessage<DeleteMyAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_delete_my_account, 0, 0);

/**
 * @generated from message protos.accounts.DeleteMyAccountResponse
 */
export type DeleteMyAccountResponse = Message<"protos.accounts.DeleteMyAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.DeleteMyAccountResponse.Result result = 1;
   */
  result?: DeleteMyAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.DeleteMyAccountResponse.
 * Use `create(DeleteMyAccountResponseSchema)` to create a new message.
 */
export const DeleteMyAccountResponseSchema: GenMessage<DeleteMyAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_delete_my_account, 1);

/**
 * @generated from message protos.accounts.DeleteMyAccountResponse.Result
 */
export type DeleteMyAccountResponse_Result = Message<"protos.accounts.DeleteMyAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.DeleteMyAccountResponse.Result.
 * Use `create(DeleteMyAccountResponse_ResultSchema)` to create a new message.
 */
export const DeleteMyAccountResponse_ResultSchema: GenMessage<DeleteMyAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_delete_my_account, 1, 0);

